function coorp_reducer(state = [], action) {
    switch (action.type) {
        case 'COORP/SET':            
            return action.coorp;
        case 'COORP/CLEAR':
            return null;
        default:
            return state;
    }
}

export default coorp_reducer;
